// extracted by mini-css-extract-plugin
export var divider = "_xz-0";